import(/* webpackMode: "eager" */ "/home/runner/work/Okkanti/Okkanti/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["SearchWidget"] */ "/home/runner/work/Okkanti/Okkanti/src/app/components/common/SearchWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationHeader"] */ "/home/runner/work/Okkanti/Okkanti/src/app/components/layouts/NavigationHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MeetYourDoulaSection"] */ "/home/runner/work/Okkanti/Okkanti/src/app/components/sections/MeetYourDoulaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesSection"] */ "/home/runner/work/Okkanti/Okkanti/src/app/components/sections/ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StayConnectedSection"] */ "/home/runner/work/Okkanti/Okkanti/src/app/components/sections/StayConnectedSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/home/runner/work/Okkanti/Okkanti/src/app/components/sections/TestimonialsSection.tsx");
